import { Injectable, inject } from '@angular/core';
import { AttributeResource } from '@df/catalog/attribute/attribute.resource';
import { Category, ICategoryDataV2 } from '@df/catalog/category/category';
import { FacetUrlService } from '@df/module-facet-url/core/facet-url.service';
import intersection from 'lodash-es/intersection';
declare module '@df/catalog/category/category' {
    interface ICategoryDataV2 {
        /**
         * Allowed attributes
         */
        facetattrs?: {
            attribute_code: string;
            attribute_options: number[];
        }[];
    }
}
@Injectable({
    providedIn: 'root'
})
export class LocalFacetUrlService extends FacetUrlService {
    protected override useHardNavigation = true;

    private attributeResource = inject(AttributeResource);
    /**
     * Retrives ordered list of attributes used for facet URLs
     */
    override getFacetAttributes(
        category: Category<ICategoryDataV2>,
        data: {
            [attrCode: string]: string | number | string[];
        }
    ): string[] {
        const categoryAttrs = category.data?.facetattrs?.map(i => i.attribute_code) || [];
        const dataAttrs = Object.keys(data);
        const attrs = intersection(categoryAttrs, dataAttrs);
        return attrs.filter(attr => {
            const attribute = this.attributeResource.getExisting(attr);
            let label = data[attr];
            if (!label) {
                return false;
            }
            if (Array.isArray(label)) {
                if (label.length !== 1) {
                    return false;
                }
                label = label[0] as string | number;
            }
            const value = attribute?.getOptionValue(label);
            if (typeof value === 'number') {
                const allowedValues = category.data?.facetattrs?.find(i => i.attribute_code === attr)?.attribute_options || [];
                return allowedValues.indexOf(value) > -1;
            }
            return false;
        });
    }
}
